import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import governanceImage from "../../resources/circa/governance.svg";

import "../../leading/Start.scss";


export const WelcomeGovernance = () => {
    return <div className="full-page">
        <h1><strong>Governance</strong></h1>
        <img src={governanceImage} alt="Governance" />
        <div onClick={() => window.location.href = "main"} className="lower-arrow"><FontAwesomeIcon icon={faArrowRight} /></div>
    </div>;
}